<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus" v-if="false">添加</el-button>
        <el-button type="primary" icon="el-icon-plus" v-if="false">导入</el-button>
        <el-button type="danger" @click="delRows" v-if="false">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row,$index }">
            <el-button key="btn2" type="text" v-if="$permission.canWrite()" @click="onEdit(row,$index)" :disabled="row.isEditBtn">{{ row.isEdit ? '保存' : '编辑' }}</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/basedata/basedoc/productprocessing/list";
import editDialog from "@/components/basedata/basedoc/productprocessing/editDialog";

export default {
  name: "summarymagent",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      api: require('@/api/ba/product').default,
    };
  },
  methods: {
    delRows() {
      // let rows = this.$refs.list.getCheckedRows();
      // if (rows.length == 0) {
      //   this.$message.warning("请选择要删除的数据");
      //   return;
      // }
      // this.$confirm("确认删除所选的数据吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     let ids = rows.map((item) => {
      //       return item.AbstractId;
      //     });
      //     this.$refs.list.delRange(ids);
      //   })
      //   .catch(() => {});
    },
    onEdit(row,index) {
      if (row.isEdit) {
        console.log('保存');
        this.$set(row, "isEdit", false);
        const params = {
          ProductId:row.ProductId,
          TemplateId:row.TemplateId,
          ProcessUnitId:row.ProcessUnitId,
          ProcessId:row.ProcessId
        }
        console.log("🚀 ~ onEdit ~ params:", params)
        this.api.saveProcessUnit(params).then(res => {
          if (res.Code == 0) {
            this.$message.success("保存成功");
            this.$refs.list.reload();
          } else {
            this.$message.warning(res.Msg);
            this.$refs.list.reload();
          }
        })
      } else {
        console.log('编辑');
        this.$refs.list.$refs.list.data.forEach((item) => {
          this.$set(item, "isEditBtn", true);
        });
        this.$set(row, "isEdit", true);
        this.$set(row, "isEditBtn", false);
      }
    },
  },
};
</script>